import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "address-list-box"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('ul', {
    staticClass: "address-list",
    attrs: {
      "id": "address"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "liclass"
    }, [_c('i', {
      staticClass: "setmy-icon",
      on: {
        "click": function ($event) {
          return _vm.delAddress(item.id);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/toc/mobile/img/icon-11.png"
      }
    })]), _c('div', {
      staticClass: "setmy-address",
      on: {
        "click": function ($event) {
          return _vm.chioseAddress(item);
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.gps_addr))]), _c('p', [_vm._v(_vm._s(item.detail_addr))])]), _c('span', {
      staticClass: "btn",
      class: item.is_default === 1 ? 'chouse-active' : '',
      on: {
        "click": function ($event) {
          return _vm.setDefault(item.id);
        }
      }
    }, [_vm._v(" " + i18n.tc("306") + " ")])]);
  }), 0), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "cursor-button",
    on: {
      "click": function ($event) {
        _vm.isShowAddress = true;
      }
    }
  }, [_c('p', {
    staticClass: "addAddress"
  }, [_vm._v(i18n.tc("139"))])])])]), _c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: _vm.isShowAddress,
      callback: function ($$v) {
        _vm.isShowAddress = $$v;
      },
      expression: "isShowAddress"
    }
  }, [_c('AddressAdd', {
    on: {
      "on-success": function ($event) {
        _vm.getList(), _vm.isShowAddress = false;
      }
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };